import { PublicServerPlaceEvent } from 'gleblu-socket-api';
import moment from 'moment-timezone';
import { put, takeEvery } from 'redux-saga/effects';

import { fromDto } from '../../../models/adapters/AccountActivationResultAdapter';
import AccountActivationResult from '../../../models/interfaces/AccountActivationResult';
import { accountActivationFailed, accountActivationFinished, activateAccount, ActivateAccountActionType } from '../../actions/registration/activateAccount';
import getPublicResponse from '../getPublicResponse';

function* activateAccountSaga({ payload }: ActivateAccountActionType) {
  const timestamp = moment();
  const { token } = payload;
  const response = yield getPublicResponse(PublicServerPlaceEvent.activateAccount, {
    token,
  });
  const { accountActivationResult: accountActivationResultDto, error } = response;
  if (error) {
    const action = accountActivationFailed({
      token,
      accountActivationResult: AccountActivationResult.failed,
      timestamp,
    });
    yield put(action);
  } else {
    const action = accountActivationFinished({
      token,
      accountActivationResult: fromDto(accountActivationResultDto),
      timestamp,
    });
    yield put(action);
  }
}

export default function* watchActivateAccountSaga() {
  yield takeEvery(activateAccount, activateAccountSaga);
}
